import { CIDService } from "./../../../../services/common/cid.service";
import { Component, OnInit, Inject } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatSelect, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { IArea } from "src/app/interfaces/area";
import { ICity } from "src/app/interfaces/city";
import { SoundEnum } from "src/app/enums/sound.enum";
import { TranslateService } from "@ngstack/translate";
import { IHolding } from "src/app/interfaces/holding";
import { IProvince } from "src/app/interfaces/province";
import { IPhoneType } from "src/app/interfaces/phoneType";
import { ErrorsService } from "src/app/services/common/errors.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ICompany } from "src/app/interfaces/company";
import { DiscountGroupService } from "src/app/services/http/business/discount-group/discount-group.service";
import { StaticValueService } from "src/app/services/http/business/staticValue/static-value.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: 'app-discount-person-add-document',
  templateUrl: './discount-person-add-document.component.html',
  styleUrls: ['./discount-person-add-document.component.css']
})
export class DiscountPersonAddDocumentComponent implements OnInit {

  cityList: ICity;
  areaList: IArea;
  form: FormGroup;
  holdingList: IHolding[];
  provinceList: IProvince;
  phoneTypeList: IPhoneType;
  ab: any;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  companyEncryptCode: string;
  companyList: ICompany[];
  discountGroupTypeList = [];

  constructor(
    private fb: FormBuilder,
    private discountGroupService: DiscountGroupService,
    private cidService: CIDService,
    private companyService: CompanyService,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private staticValueService: StaticValueService,
    private dialogRef: MatDialogRef<DiscountPersonAddDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  ngOnInit() {
    this.createForm();
    this.getDiscountGroupType();
    this.getCompanyList();
  }
  createForm() {
    console.log(this.data);

    this.form = this.fb.group({
      CompanyEncryptId: [this.data && this.data["CompanyEncryptId"] ? this.data["CompanyEncryptId"].toString() : null, !this.data ? Validators.required : null],
      DiscountGroupTypeId: [this.data && this.data["DiscountGroupTypeId"] ? this.data["DiscountGroupTypeId"].toString() : null, !this.data ? Validators.required : null],
      Title: [this.data && this.data["Title"] ? this.data["Title"].toString() : null, Validators.required],
      DiscountPercent: [this.data && this.data["DiscountPercent"] ? this.data["DiscountPercent"].toString() : null, Validators.compose([Validators.required, Validators.min(1), Validators.max(100)])],
      Description: [this.data && this.data["Description"] ? this.data["Description"].toString() : ''],
      IsNeedToCheck: [false]
    });
  }
  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  getDiscountGroupType() {
    this.staticValueService.discountGroupType(false).subscribe(res => {
      console.log(res);
      this.discountGroupTypeList = res;
      console.log(this.discountGroupTypeList);
    })
  }

  setCID(e: MatSelect) {
    this.cidService.setCID(e.value);
  }

  submit(form: any) {

    this.errors = new Array();
    if (this.data) {
      let model = {
        DiscountGroupTypeId: form.DiscountGroupTypeId,
        Title: form.Title,
        DiscountPercent: form.DiscountPercent,
        IsNeedToCheck: form.IsNeedToCheck,
        Description: form.Description,
        Id: this.data.Id
      };
      this.discountGroupService.editNonClass(model).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.saveNonClassDiscountGroup"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    } else {
      let model = {
        DiscountGroupTypeId: form.DiscountGroupTypeId,
        Title: form.Title,
        DiscountPercent: form.DiscountPercent,
        IsNeedToCheck: form.IsNeedToCheck,
        Description: form.Description
      };
      this.discountGroupService.addNonClass(model).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.saveNonClassDiscountGroup"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    }
  }




  onNoClick() {
    this.dialogRef.close();
  }

}
